import { render } from "./product-details.vue?vue&type=template&id=07ed0edd"
import script from "./product-details.vue?vue&type=script&lang=js"
export * from "./product-details.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-MakProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__